export const bookTranslations = {
  en: {
    "seo.book.title": "The Founder Laws — 50 Hard Truths for Startup Survival",
    "seo.book.description":
      "A practical ebook: 50 founder laws, each with an AI prompt to apply directly to how you're building your company. Instant digital download.",

    "book.topbar": "Instant Download · Founder eBook · Offer Price ${price} {currency}",

    "book.hero.eyebrow": "Stop Losing Time, Cash & Momentum",
    "book.hero.title": "The Founder Laws",
    "book.hero.subtitle": "50 Hard Truths for Startup Survival.",
    "book.hero.lede":
      "The brutally practical ebook for founders who want to make better decisions, avoid expensive mistakes, and build with more discipline.",
    "book.hero.body":
      "Most startups don't fail because the founder lacks ambition. They fail because they misread reality, burn resources badly, hire too early, avoid selling, and lose focus when it matters most.",
    "book.hero.bodyStrong": "This book helps you fix that.",
    "book.hero.trust": "Instant digital download · Secure checkout via Shopify",
    "book.hero.coverAlt": "The Founder Laws ebook cover",

    "book.cta.getInstantAccess": "Get Instant Access for ${price}",
    "book.cta.seeWhatsInside": "See What's Inside",
    "book.cta.buyForPrice": "Buy The Founder Laws for ${price}",
    "book.cta.downloadNow": "Download the eBook Now for ${price}",
    "book.cta.getEbook": "Get the eBook for ${price}",
    "book.cta.buyNow": "Buy Now",

    "book.problem.eyebrow": "The Core Problem",
    "book.problem.title": "Founders don't need more noise. They need better judgment.",
    "book.problem.p1":
      "You don't need another vague startup book full of recycled inspiration and generic advice.",
    "book.problem.p2":
      "You need clear, hard-earned lessons on what actually matters when you're trying to survive the early stage.",
    "book.problem.p3":
      "The Founder Laws gives you 50 direct, practical founder truths across the areas that make or break a business:",
    "book.problem.list.0": "cash and runway",
    "book.problem.list.1": "hiring and team culture",
    "book.problem.list.2": "product and iteration",
    "book.problem.list.3": "sales and customer reality",
    "book.problem.list.4": "focus, execution, and founder psychology",
    "book.problem.list.5": "brand, trust, and strategic positioning",

    "book.inside.eyebrow": "What's Inside",
    "book.inside.title": "50 Founder Lessons. 5 Critical Pillars. 1 Smarter Way to Build.",
    "book.inside.lede":
      "Sharp, actionable lessons across five core founder pillars — each paired with an AI prompt you can drop into your favourite AI tool.",

    "book.ai.eyebrow": "Built for the AI Era",
    "book.ai.title": "Every law comes with its own AI prompt.",
    "book.ai.body":
      "Drop each prompt into ChatGPT, Claude, Gemini, or your AI tool of choice and turn the lesson into a working session for your startup. Pressure-test decisions, draft plans, and apply each law directly to how you're building — not in theory, in practice.",
    "book.ai.list.0": "50 ready-to-use prompts",
    "book.ai.list.1": "Works with any AI tool",
    "book.ai.list.2": "Apply lessons to your real context",
    "book.ai.list.3": "Move from reading to executing",
    "book.ai.promptLabel": "// AI Prompt · Law 07",
    "book.ai.promptText":
      "\"Act as a brutally honest startup advisor. Using my context below, pressure-test my runway assumptions and surface the 3 decisions I'm avoiding…\"",

    "book.pillars.0.title": "Financial & Resource Engine",
    "book.pillars.0.body":
      "Protect your runway, reduce waste, charge earlier, and stop treating cash like a future problem.",
    "book.pillars.1.title": "Talent & Cultural Framework",
    "book.pillars.1.body":
      "Build a stronger founding team, hire with better judgment, and create a culture that handles real pressure.",
    "book.pillars.2.title": "Product Iteration & Market Execution",
    "book.pillars.2.body":
      "Ship faster, test earlier, listen harder, and turn customer feedback into momentum.",
    "book.pillars.3.title": "Strategic Focus & Founder Psychology",
    "book.pillars.3.body":
      "Stop chasing distractions, decide faster, protect your energy, and stay focused on what moves the company.",
    "book.pillars.4.title": "Brand, Positioning & Ecosystem",
    "book.pillars.4.body":
      "Build trust, sharpen your market position, communicate clearly, and avoid mistakes that damage credibility.",
    "book.pillars.tag": "+ AI Prompts",
    "book.pillars.summary.title": "50 Laws · 50 Prompts",
    "book.pillars.summary.body":
      "Read the lesson. Run the prompt. Apply it to your startup the same day.",

    "book.benefits.eyebrow": "Why Founders Buy This Book",
    "book.benefits.title": "Because startup mistakes are expensive.",
    "book.benefits.line.0": "A bad hire costs time.",
    "book.benefits.line.1": "A weak offer costs momentum.",
    "book.benefits.line.2": "Poor focus kills execution.",
    "book.benefits.line.3": "Delaying sales destroys clarity.",
    "book.benefits.line.4": "Ignoring reality burns runway.",
    "book.benefits.body":
      "The Founder Laws was written to help founders think better, act faster, and avoid preventable damage. Not theory-heavy. Direct. Practical. Written for people building under pressure.",
    "book.benefits.list.0": "Cut through founder overwhelm",
    "book.benefits.list.1": "Make sharper decisions under pressure",
    "book.benefits.list.2": "Avoid common early-stage mistakes",
    "book.benefits.list.3": "Stay focused on cash, customers, and execution",
    "book.benefits.list.4": "Pressure-test your thinking each chapter",
    "book.benefits.list.5": "Turn lessons into action immediately",

    "book.audience.eyebrow": "Who It's For",
    "book.audience.title": "This book is for you if…",
    "book.audience.list.0": "You are building a startup and want clearer founder judgment",
    "book.audience.list.1": "You are early-stage and need practical execution, not hype",
    "book.audience.list.2":
      "You are a technical founder trying to get better at sales and market reality",
    "book.audience.list.3": "You are pre-seed, seed, or pre-scale and want fewer blind spots",
    "book.audience.list.4":
      "You are tired of startup content that sounds smart but doesn't help you act",
    "book.audience.closing":
      "If you're trying to survive the hardest stage of building a business, this book belongs on your screen.",

    "book.different.eyebrow": "What Makes It Different",
    "book.different.title": "Not a bedtime story. A founder workbook.",
    "book.different.p1": "This ebook is built to be used.",
    "book.different.p2":
      "Each chapter gives you a clear lesson and a practical prompt to help you think harder, decide faster, and execute better.",
    "book.different.p3Strong": "You're not just reading startup advice. You're using it.",
    "book.different.p4": "Open this book when:",
    "book.different.list.0": "your runway is getting tight",
    "book.different.list.1": "your team is stretching thin",
    "book.different.list.2": "your product is stalling",
    "book.different.list.3": "your sales are inconsistent",
    "book.different.list.4": "your focus is slipping",
    "book.different.list.5": "your business needs clearer decisions now",

    "book.faq.eyebrow": "FAQ",
    "book.faq.title": "Frequently Asked Questions",
    "book.faq.0.q": "What is The Founder Laws?",
    "book.faq.0.a":
      "A practical ebook for founders, packed with 50 hard truths about startup survival, execution, decision-making, sales, hiring, focus, and growth.",
    "book.faq.1.q": "Who is this book best for?",
    "book.faq.1.a":
      "Early-stage founders, startup operators, technical founders, and builders who want practical guidance instead of startup fluff.",
    "book.faq.2.q": "Is this a physical book or digital download?",
    "book.faq.2.a": "This is a digital ebook. Instant download after purchase.",
    "book.faq.3.q": "What makes this different from other startup books?",
    "book.faq.3.a":
      "Most startup books are broad, motivational, or theory-heavy. This one is sharper, more direct, and focused on the real mistakes that kill early-stage companies.",
    "book.faq.4.q": "Will this help if I'm still at the idea or MVP stage?",
    "book.faq.4.a":
      "Yes. In fact, that's one of the best times to read it. The earlier you spot bad assumptions, the less time and money you waste.",
    "book.faq.5.q": "How much does it cost?",
    "book.faq.5.a": "The offer price is ${price} {currency}.",
    "book.faq.6.q": "How fast can I access it?",
    "book.faq.6.a": "Immediately after purchase via instant digital download.",

    "book.final.eyebrow": "Final Word",
    "book.final.title": "One sharp decision can save you months of wasted effort.",
    "book.final.p1":
      "If you're serious about building a startup that survives the early stage, this book will help you think more clearly and execute more effectively.",
    "book.final.p2": "Get The Founder Laws today for just ${price}.",
    "book.final.line.0": "50 hard truths.",
    "book.final.line.1": "5 essential founder pillars.",
    "book.final.line.2": "One practical guide to surviving startup reality.",
    "book.final.trust": "Instant digital download · Secure checkout via Shopify",

    "book.toast.loadError": "Couldn't load product. Please refresh.",
    "book.toast.checkoutError": "Couldn't reach Shopify. Please refresh and try again.",
    "book.toast.addedToCart": "Added to cart. Open the cart to checkout.",
  },
  zh: {
    "seo.book.title": "The Founder Laws——创业者必须面对的50条生存法则",
    "seo.book.description":
      "一本实用的电子书：50条创业法则，每一条都配有可直接应用到你公司经营中的AI提示词。付款后立即下载。",

    "book.topbar": "即时下载 · 创业者电子书 · 优惠价 ${price} {currency}",

    "book.hero.eyebrow": "别再浪费时间、现金和势头",
    "book.hero.title": "The Founder Laws",
    "book.hero.subtitle": "创业者必须面对的50条生存法则。",
    "book.hero.lede":
      "这是一本极其务实的电子书，写给想要做出更好决策、避免代价高昂的失误、以更强纪律性把公司做起来的创业者。",
    "book.hero.body":
      "大多数创业公司失败，不是因为创始人缺乏野心，而是因为他们误判了现实，资源浪费严重，招人太早，回避销售，并在最关键的时候失去了专注。",
    "book.hero.bodyStrong": "这本书能帮你解决这些问题。",
    "book.hero.trust": "即时数字下载 · 通过 Shopify 安全结账",
    "book.hero.coverAlt": "The Founder Laws 电子书封面",

    "book.cta.getInstantAccess": "立即获取，仅需 ${price}",
    "book.cta.seeWhatsInside": "查看书中内容",
    "book.cta.buyForPrice": "以 ${price} 购买 The Founder Laws",
    "book.cta.downloadNow": "立即下载电子书，仅需 ${price}",
    "book.cta.getEbook": "获取电子书，仅需 ${price}",
    "book.cta.buyNow": "立即购买",

    "book.problem.eyebrow": "核心问题",
    "book.problem.title": "创业者不缺信息噪音，缺的是更好的判断力。",
    "book.problem.p1": "你不需要再读一本充斥着老生常谈和泛泛建议的创业书。",
    "book.problem.p2": "你需要的是那些真正经过验证的经验，告诉你在早期阶段生存下来最重要的是什么。",
    "book.problem.p3":
      "The Founder Laws 提炼出50条直接、实用的创业法则，覆盖决定公司成败的关键领域：",
    "book.problem.list.0": "现金与资金周转",
    "book.problem.list.1": "招聘与团队文化",
    "book.problem.list.2": "产品与迭代",
    "book.problem.list.3": "销售与客户现实",
    "book.problem.list.4": "专注、执行与创始人心态",
    "book.problem.list.5": "品牌、信任与战略定位",

    "book.inside.eyebrow": "书中内容",
    "book.inside.title": "50条创业法则，5大核心支柱，1种更聪明的做事方式。",
    "book.inside.lede":
      "五大创业核心支柱下的实用经验，每一条都配有一个可直接输入你常用AI工具的提示词。",

    "book.ai.eyebrow": "为AI时代而生",
    "book.ai.title": "每一条法则都配有专属的AI提示词。",
    "book.ai.body":
      "把每个提示词输入 ChatGPT、Claude、Gemini 或你常用的AI工具，把这些经验变成一次针对你自己公司的实操会话。用它压力测试你的决策、起草计划，把每条法则真正落到你正在做的事情上——不是纸上谈兵,而是马上能用。",
    "book.ai.list.0": "50个即用型提示词",
    "book.ai.list.1": "适用于任何AI工具",
    "book.ai.list.2": "把经验应用到你的真实场景",
    "book.ai.list.3": "从阅读走向执行",
    "book.ai.promptLabel": "// AI 提示词 · 法则 07",
    "book.ai.promptText":
      "“扮演一个毫不留情的创业顾问。根据我下面提供的情况，压力测试我对资金周转的假设，并指出我一直在回避的3个决定……”",

    "book.pillars.0.title": "资金与资源管理",
    "book.pillars.0.body": "守住你的资金周转，减少浪费，尽早收费，别再把现金问题留到以后再解决。",
    "book.pillars.1.title": "人才与团队文化",
    "book.pillars.1.body": "打造更强的创始团队,提升招聘判断力,建立一种能扛住真实压力的团队文化。",
    "book.pillars.2.title": "产品迭代与市场执行",
    "book.pillars.2.body": "更快上线、更早测试、更认真倾听，把客户反馈转化为增长动力。",
    "book.pillars.3.title": "战略专注与创始人心态",
    "book.pillars.3.body": "不再追逐无关紧要的事情，更快做决定，保护好自己的精力，始终聚焦真正能推动公司前进的事。",
    "book.pillars.4.title": "品牌、定位与生态",
    "book.pillars.4.body": "建立信任，明确市场定位，清晰沟通，避免损害信誉的失误。",
    "book.pillars.tag": "+ AI 提示词",
    "book.pillars.summary.title": "50条法则 · 50个提示词",
    "book.pillars.summary.body": "读懂道理，跑一遍提示词，当天就把它用到你的公司里。",

    "book.benefits.eyebrow": "创业者为什么买这本书",
    "book.benefits.title": "因为创业失误的代价很高。",
    "book.benefits.line.0": "一次错误的招聘,浪费的是时间。",
    "book.benefits.line.1": "一份没有竞争力的报价,消耗的是势头。",
    "book.benefits.line.2": "缺乏专注,拖垮的是执行力。",
    "book.benefits.line.3": "拖延销售,模糊的是判断。",
    "book.benefits.line.4": "无视现实,烧掉的是资金周转。",
    "book.benefits.body":
      "《The Founder Laws》就是为了帮助创业者想得更清楚、行动更迅速、避免本可以避免的损失而写的。不空谈理论，直接、务实，写给在压力下做事的人。",
    "book.benefits.list.0": "摆脱创业者的信息过载",
    "book.benefits.list.1": "在压力下做出更精准的决策",
    "book.benefits.list.2": "避开早期阶段的常见错误",
    "book.benefits.list.3": "始终聚焦现金、客户与执行",
    "book.benefits.list.4": "每一章都在压力测试你的思路",
    "book.benefits.list.5": "把每条经验立刻转化为行动",

    "book.audience.eyebrow": "适合谁读",
    "book.audience.title": "如果你符合以下情况，这本书适合你……",
    "book.audience.list.0": "你正在创业，想让自己的判断更清晰",
    "book.audience.list.1": "你处于早期阶段，需要的是实用的执行方法,而不是空洞的口号",
    "book.audience.list.2": "你是技术出身的创始人，想在销售和市场现实方面做得更好",
    "book.audience.list.3": "你处于种子轮前后或规模化之前，想减少盲点",
    "book.audience.list.4": "你已经厌倦了那些听起来很有道理、却对行动毫无帮助的创业内容",
    "book.audience.closing": "如果你正在努力度过创业最艰难的阶段，这本书值得放在你的屏幕上。",

    "book.different.eyebrow": "它的不同之处",
    "book.different.title": "不是床边故事，而是一本创业者工作手册。",
    "book.different.p1": "这本电子书是拿来用的，不是拿来摆的。",
    "book.different.p2": "每一章都给你一条清晰的经验，加一个能帮你想得更深、决定得更快、执行得更好的实用提示词。",
    "book.different.p3Strong": "你不只是在读创业建议，你是在使用它。",
    "book.different.p4": "在以下时刻打开这本书：",
    "book.different.list.0": "资金周转越来越紧张的时候",
    "book.different.list.1": "团队人手越来越吃紧的时候",
    "book.different.list.2": "产品进展停滞的时候",
    "book.different.list.3": "销售业绩起伏不定的时候",
    "book.different.list.4": "专注力开始下降的时候",
    "book.different.list.5": "公司现在就需要更清晰决策的时候",

    "book.faq.eyebrow": "常见问题",
    "book.faq.title": "常见问题解答",
    "book.faq.0.q": "The Founder Laws 是什么？",
    "book.faq.0.a":
      "一本写给创业者的实用电子书，包含50条关于创业生存、执行力、决策、销售、招聘、专注与增长的经验法则。",
    "book.faq.1.q": "这本书最适合谁读？",
    "book.faq.1.a":
      "早期创业者、创业公司的运营者、技术出身的创始人，以及所有希望得到实用指导而非空谈的创业者。",
    "book.faq.2.q": "这是纸质书还是电子版？",
    "book.faq.2.a": "这是一本电子书，购买后即可立即下载。",
    "book.faq.3.q": "它和其他创业类书籍有什么不同？",
    "book.faq.3.a":
      "大多数创业类书籍内容宽泛、偏励志或偏理论。这本书更犀利、更直接，聚焦于真正会拖垮早期公司的那些错误。",
    "book.faq.4.q": "如果我还处于想法或MVP阶段，这本书有帮助吗？",
    "book.faq.4.a":
      "有。事实上，这正是阅读它的最佳时机之一。你越早发现错误的假设，浪费的时间和金钱就越少。",
    "book.faq.5.q": "这本书多少钱？",
    "book.faq.5.a": "优惠价为 ${price} {currency}。",
    "book.faq.6.q": "购买后多久能拿到？",
    "book.faq.6.a": "付款成功后即可立即下载，无需等待。",

    "book.final.eyebrow": "最后一句话",
    "book.final.title": "一个正确的决定，能为你省下数月的白费功夫。",
    "book.final.p1":
      "如果你是认真想让自己的创业公司挺过早期阶段，这本书能帮你想得更清楚、执行得更有效。",
    "book.final.p2": "现在就以 ${price} 的价格获取 The Founder Laws。",
    "book.final.line.0": "50条生存法则。",
    "book.final.line.1": "5大创业核心支柱。",
    "book.final.line.2": "1份帮你度过创业现实的实用指南。",
    "book.final.trust": "即时数字下载 · 通过 Shopify 安全结账",

    "book.toast.loadError": "商品加载失败，请刷新页面重试。",
    "book.toast.checkoutError": "无法连接到 Shopify，请刷新页面后重试。",
    "book.toast.addedToCart": "已加入购物车，打开购物车即可结账。",
  },
} as const;
